import AppAufaFlightCar from '../AufaFlighetCar/AppAufaFlightCar';
import ProjectSelectContiner from './ProjectSelectContiner';
import './AppAufaProjects.css';


export default function AppAufaProjects({ setClose, flight, setFlight, setDataMain, projectSelect, setProjectSelect, dataFlightCar, setDataFlightCar, insertFlightCar, setSettingProject }) {

    const closeProject = () => {
        setDataFlightCar({ fa: [], fr: [], ca: [], cr: [] });
        setProjectSelect({ name: '', id: '' });
        setDataMain({});
    }

    return (<>
        <div className='main-docket aufaProjects'>
            <ProjectSelectContiner
                flight={flight}
                setClose={setClose}
                onClick={(name) => setProjectSelect({ name: name, id: '' })}
            />
        </div>

        {projectSelect.name &&
            <AppAufaFlightCar
                name={projectSelect.name}
                setClose={closeProject}
                flight={flight}
                setFlight={setFlight}
                setDataMain={setDataMain}
                setProjectId={(num) => setProjectSelect({ id: num, name: projectSelect.name })}
                dataFlightCar={dataFlightCar}
                setDataFlightCar={setDataFlightCar}
                insertFlightCar={insertFlightCar}
                setSettingProject={setSettingProject}
            />}

    </>)
}